import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  routeDirectory
} from 'modules';

import { Table } from 'iron-forge-react-modules';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as dataService from './dataService';
import * as types from './types';



const TableComponent = Table.genTableComponent<types.IColumnId>();

export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();
  const navigate = useNavigate();



  const rows = React.useMemo(
    () => _.map(queryTuple.data.agreements, (agreement): types.IRow => ({
      id: agreement.id,
      columnId2Value: {
        orderNumber: {
          type: 'string',
          label: agreement.orderNumber
        },
        orderDate: {
          type: 'string',
          label: agreement.orderDate.toFormat('yyyy-MM-dd @ hh:mm a')
        },
        productName: {
          type: 'string',
          label: agreement.productName
        },
        sku: {
          type: 'string',
          label: agreement.sku
        },
        agreementNumber: {
          type: 'string',
          label: agreement.agreementNumber || '-'
        },
        activatedAt: {
          type: 'string',
          label: agreement.activatedAt ? agreement.activatedAt.toFormat('yyyy-MM-dd') : '-'
        }
      }
    })),
    [queryTuple]
  );

  return (
    <BaseWidget.FC
      title="AppleCare Agreements"
      elAction={(
        <Button onClick={() => navigate(routeDirectory.admin.appleCareAgreements.path())}>
          View All
        </Button>
      )}>
      <TableComponent
        disableSorting
        rows={rows}
        columns={[
          {
            id: 'orderNumber',
            label: "Order Number"
          },
          {
            id: 'orderDate',
            label: "Order Date"
          },
          {
            id: 'productName',
            label: "Product Name"
          },
          {
            id: 'sku',
            label: "SKU"
          },
          {
            id: 'agreementNumber',
            label: "Agreement Number"
          },
          {
            id: 'activatedAt',
            label: "Activated At"
          }
        ]} />
    </BaseWidget.FC>
  );
};
